<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import {
		DropdownMenuV2,
		DropdownMenuItemV2,
		ButtonV2,
		Modal,
		SelectCardV2,
		CardGrid,
	} from '@Shelly/shelly-design-system';
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { format } from 'src/services/i18n';

	export let showDropdown: boolean = false;
	export let dropdownItems: {
		language: string;
		subtitle: string;
		title: string;
	}[];
	export let lang: string;
	export let selectedLang: string;

	const dispatch = createEventDispatcher();

	let windowClientWidth: number;
	let showModal = false;

	$: isMobileOrTablet = windowClientWidth <= SystemScreenBreakpoints.TABLET_MAX;

	const handleLanguageSelect = (menuItem: (typeof dropdownItems)[0]) => {
		dispatch('change-lang', menuItem);
		if (isMobileOrTablet) {
			showModal = false;
		} else {
			showDropdown = false;
		}
	};

	const handleTriggerClick = () => {
		if (isMobileOrTablet) {
			showModal = true;
		} else {
			showDropdown = !showDropdown;
		}
	};

	const closeModal = () => {
		showModal = false;
	};
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

{#if isMobileOrTablet}
	<ButtonV2 variant="secondary" size="m" on:click={handleTriggerClick}>
		{lang}
	</ButtonV2>

	<Modal bind:showModal on:close={closeModal} hideTitle>
		<svelte:fragment slot="content">
			<CardGrid md={250} noPaddingBottom gridGap="s" class="mt-s mb-s">
				{#each dropdownItems as menuItem}
					<SelectCardV2
						hideAction
						type="horizontal"
						class="width-full"
						title={menuItem.title}
						selected={selectedLang === menuItem.language}
						on:click={() => handleLanguageSelect(menuItem)}
					/>
				{/each}
			</CardGrid>
		</svelte:fragment>
	</Modal>
{:else}
	<DropdownMenuV2 bind:show={showDropdown}>
		<ButtonV2 slot="trigger" variant="secondary" size="m" on:click={handleTriggerClick}>
			{lang}
		</ButtonV2>
		{#each dropdownItems as menuItem}
			<DropdownMenuItemV2
				title={menuItem.title}
				isSelectable
				selected={selectedLang === menuItem.language}
				on:click={() => handleLanguageSelect(menuItem)}
			/>
		{/each}
	</DropdownMenuV2>
{/if}
